const messages = {
    en: {
      subject: "Subject",
      active: "Active",
      questionNumber: "Questions number",
      edit: "Edit",
      delete: "Delete",
      createdAt: "Created At",
      status: "Status",
      userName: "User Name",
      pending:"Pending",
      declined:"Declined",
      approved: "Approved",
      noAddedQuestions: "No added questions",
    },
    ru: {
        subject: "Предмет",
        active: "Активный",
        questionNumber: "Количество вопросов",
        edit: "Править",
        delete: "Удалить",
        createdAt: "Дата создания",
        status: "Cтатус",
        userName: "Имя пользователя",
        pending:"В ожидании",
        declined:"Отклоненный",
        approved: "Одобренный",
        noAddedQuestions: "Нет добавленных вопросов",
    }
  };

  export default messages;